import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SidebarPageLink,
  SidebarRoute,
  SideBtnWrap
} from './SidebarElements';

const Sidebar = ({ isOpen, toggle }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const homeLinkWithScroll = (sectionId) => ({ pathname: '/', state: { scrollTo: sectionId } });

  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          {isHome ? (
            <SidebarLink to="about" onClick={toggle} smooth={true} duration={500} spy={true} exact="true" offset={-80}>
              About
            </SidebarLink>
          ) : (
            <SidebarPageLink to={homeLinkWithScroll('about')} onClick={toggle}>
              About
            </SidebarPageLink>
          )}
          {isHome ? (
            <SidebarLink to="expertise" onClick={toggle} smooth={true} duration={500} spy={true} exact="true" offset={-80}>
              Expertise
            </SidebarLink>
          ) : (
            <SidebarPageLink to={homeLinkWithScroll('expertise')} onClick={toggle}>
              Expertise
            </SidebarPageLink>
          )}
          <SidebarPageLink to="/service/seo" onClick={toggle}>
            SEO
          </SidebarPageLink>
          <SidebarPageLink to="/service/social-media" onClick={toggle}>
            Social Media
          </SidebarPageLink>
          <SidebarPageLink to="/service/digital" onClick={toggle}>
            Digital & Virtual Tours
          </SidebarPageLink>
          <SidebarPageLink to="/meet-the-team" onClick={toggle}>
            Meet the Team
          </SidebarPageLink>
          {isHome ? (
            <SidebarLink to="contactus" onClick={toggle} smooth={true} duration={500} spy={true} exact="true" offset={-80}>
              Careers
            </SidebarLink>
          ) : (
            <SidebarPageLink to={homeLinkWithScroll('contactus')} onClick={toggle}>
              Careers
            </SidebarPageLink>
          )}
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute to="/getquote" onClick={toggle}>Get Quote</SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
